/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Error_Provider_HttpInputs */

const vi_einvoice_error_provider_http = /** @type {(inputs: Einvoice_Error_Provider_HttpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MISA từ chối request hóa đơn. Vui lòng nhờ kế toán kiểm tra cấu hình và dữ liệu hóa đơn.`)
};

/**

* @param {Einvoice_Error_Provider_HttpInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_error_provider_http = /** @type {((inputs?: Einvoice_Error_Provider_HttpInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Error_Provider_HttpInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_error_provider_http(inputs)
});